import { HttpRequest } from "../utils"

const httpRequest = new HttpRequest()

export interface ICodConfig {
  enabled: boolean
  maxAmountPerDn: number | null
  paymentMethods: string[]
  requireCodReceiptPhoto: boolean
  maxDailyCodPerDriver: number | null
}

export interface IGovernanceConfig {
  businessId: string
  buyerSmsNotificationsEnabled: boolean
  inventoryAllocationStrategy: string
  vehicleCapacityThresholds: unknown | null
  localChannelCoordinatorRoles: string[]
  supplyChannelCoordinatorRoles: string[]
  routePlannerRoles: string[]
  shortageDecisionPolicy: string
  shortageReviewThresholdPercent: number
  shortageEscalationThresholdPercent: number
  failureEvidenceRules: Record<string, { requirePhoto: boolean }>
  failedDeliveryFeePolicy: string
  terminationPolicy: string
  terminationMaxAttempts: number
  escalationMatrix: Record<string, { timeoutHours: number; notifyRole: string }>
  channelLabels: Record<string, string>
  idempotency: {
    keyTtlHours: number
    requireOnMutation: boolean
    assignmentVersioning: boolean
  }
  inboundFlow: {
    crossWarehouseSourcing: { enabled: boolean; priorityChain: string[] }
    autoCreateStoOnShortage: boolean
    externalPickupEnabled: boolean
    requireSenderVerifyAtExternalParty: boolean
    catalogAutoCreateOnReceipt: boolean
    requireManagerApprovalForInbound: boolean
    defaultExternalPartyApprovalRole: string[]
  }
  orderCutoffTime: string
  workingDays: ("MON" | "TUE" | "WED" | "THU" | "FRI" | "SAT" | "SUN")[]
  workingHours: {
    start: string
    end: string
  }
  codConfig: ICodConfig
  smsConfig: {
    enabled: boolean
    templates: Record<string, unknown>
    operatorPreference: string
  }
}

export const get = async (): Promise<IGovernanceConfig> =>
  httpRequest.get("/ord/governance-config")

export const update = async (patch: Partial<IGovernanceConfig>): Promise<IGovernanceConfig> =>
  httpRequest.put("/ord/governance-config", patch as any)

export type DeliveryDateReason =
  | "WEEKEND"
  | "HOLIDAY"
  | "PAST_CUTOFF_TODAY"
  | "PAST_CUTOFF_TOMORROW"
  | "SAME_DAY_NOT_ALLOWED"

export interface IDateAvailability {
  date: string
  available: boolean
  reasonIfUnavailable: DeliveryDateReason | null
}

export interface IAvailableDeliveryDatesResponse {
  businessId: string
  fromDate: string
  days: number
  hasOverride: boolean
  dates: IDateAvailability[]
}

export interface IAvailableDeliveryDatesParams {
  businessId?: string
  from?: string
  days?: number
}

export const availableDeliveryDates = async (
  params: IAvailableDeliveryDatesParams = {},
): Promise<IAvailableDeliveryDatesResponse> => {
  const query: Record<string, string | number> = {}
  if (params.businessId) query.businessId = params.businessId
  if (params.from) query.from = params.from
  if (params.days != null) query.days = params.days
  return httpRequest.get("/ord/governance-config/available-delivery-dates", query)
}
